import { startupsPath, startupsUrl } from '@src/lib/startups-url'

export const SESSION_FEE_WAIVE_CODE_MIN_LEN = 3
export const SESSION_FEE_WAIVE_CODE_MAX_LEN = 32
const CODE_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export const normalizeSessionFeeWaiveCode = (raw: unknown): string | null => {
  if (raw == null) {
    return null
  }
  const code = String(raw).trim().toLowerCase()
  if (!code) {
    return null
  }
  if (code.length < SESSION_FEE_WAIVE_CODE_MIN_LEN || code.length > SESSION_FEE_WAIVE_CODE_MAX_LEN) {
    return null
  }
  if (!CODE_RE.test(code)) {
    return null
  }
  return code
}

export const isSessionFeeWaiveCodeValid = (raw: string): boolean => normalizeSessionFeeWaiveCode(raw) != null

/** Default coupon from the member slug, or a short fallback. */
export const suggestSessionFeeWaiveCode = (slug?: string | null): string => {
  const fromSlug = String(slug || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SESSION_FEE_WAIVE_CODE_MAX_LEN)
  if (fromSlug.length >= SESSION_FEE_WAIVE_CODE_MIN_LEN) {
    return fromSlug
  }
  return 'comp'
}

export const advisorUserProfileHref = (slug: string): string => startupsUrl(`/members/${slug}`)

/** Public book page on the member profile — no Advisors chrome. */
export const advisorBookSessionPath = (memberSlugOrId: string, waiveCode?: string | null): string =>
  startupsPath(`/members/${memberSlugOrId}/book`, waiveCode ? { waive: waiveCode } : null)

export const advisorBookSessionHref = (memberSlugOrId: string, waiveCode?: string | null): string =>
  startupsUrl(advisorBookSessionPath(memberSlugOrId, waiveCode))
